/* eslint-disable css-modules/no-unused-class  */
import { FC } from 'react';
import { coreService } from 'network-utils';
import styles from './homeRightSide.module.scss';
import AchievementsExpandedContainer from '../achievements/achievementsExpandedContainer';
import AssignedContent from '../assignedContent/assignedContent';
import Leaderboard from '../leaderboard/leaderboard';

const HomeRightSide: FC<HomeRightSideProps> = (props: HomeRightSideProps) => {
    const { fullWidth, courseRate, lessonsRate, assessmentsRate, teamsLeaderboard, usersLeaderboard, onlyUsers } =
        props;
    return (
        <>
            <div id="home-right-side" className={styles['home-right-side']}>
                <AchievementsExpandedContainer showLeaderboard={Boolean(usersLeaderboard)} fullWidth={fullWidth} />
                {usersLeaderboard && (
                    <Leaderboard
                        teamsLeaderboard={teamsLeaderboard}
                        usersLeaderboard={usersLeaderboard}
                        onlyUsers={onlyUsers}
                    />
                )}
                <AssignedContent courseRate={courseRate} lessonsRate={lessonsRate} assessmentsRate={assessmentsRate} />
            </div>
        </>
    );
};

export interface HomeRightSideProps {
    fullWidth: boolean;
    teamsLeaderboard: coreService.HomeTeamLeaderboardResponse | undefined;
    usersLeaderboard: coreService.HomeLeaderboardResponse | undefined;
    onlyUsers: boolean;
    courseRate: any;
    lessonsRate: any;
    assessmentsRate: any;
}

export default HomeRightSide;
